module.exports = __webpack_public_path__ + "img/0Q3A4704_FoamcoreMatted.ece5add8.jpg";